import React from 'react'
import { Form } from 'react-bootstrap'


export default function Email(props) {
  const { label_name, placeholder, disabled, name, value,required, onChange,error, onBlur } = props
  return (
    <>
      <Form.Group className="mb-3" controlId="email">
        <Form.Label className='form_label'>{label_name}{required == true ? <span className='required_filed'>*</span>:""}</Form.Label>
        <Form.Control
          type="email"
          placeholder={placeholder}
          disabled={disabled}
          className='form_input'
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {error}
      </Form.Group>
    </>
  )
}
